module.exports = __webpack_public_path__ + "img/esdi.4e64b76e.png";